
import { Invoice } from "@/types/Invoice";
import PaginationType from "@/types/Pagination";
import { PropType, defineComponent, ref } from "vue";
import Pagination from "../General/Pagination.vue";
import { Link } from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import Card from "../General/Card.vue";
import { debounce } from "lodash";

export default defineComponent({
  props: {
    invoices: {
      type: Object as PropType<PaginationType<Invoice>>,
    },
  },
  setup(props) {
    const paginationSize = ref();

    const checkSize = (event?: Event) => {
      paginationSize.value = "sm";
      console.log(window.innerWidth);

      if (window.innerWidth > 768) {
        paginationSize.value = "md";
      }

      if (window.innerWidth > 1080) {
        paginationSize.value = "lg";
      }
    };

    window.addEventListener("resize", debounce(checkSize, 250));

    checkSize();

    return {
      paginationSize,
      dayjs,
      route,
    };
  },
  components: { Pagination, Link, Card },
});
